define('flight-components/mixins/withCaptcha',['require','flight/lib/compose','App'],function(require){

  // Dependencies
  var compose = require('flight/lib/compose');
  var App = require('App');
  
  return withCaptcha;
  
  // Constructor
  function withCaptcha() {

    this.defaultAttrs({
      captchaInputSelector: 'input[name="code"]',
      captchaImageSelector: '.captcha__image'
    });

    this.getCaptcha = function() {
      var $img = this.select('captchaImageSelector');
      var src = $img.attr('src');
      $img.attr('src', src + '&t=' + new Date().getTime());
    };

    this.resetCaptcha = function() {
      this.getCaptcha();
      this.select('captchaInputSelector').val('');
    };
   

    this.after('initialize', function() {
      
      this.on('data-form-validation-errors-returned', this.resetCaptcha);

    });

  };
});
